'use client';

import { Box, Divider } from '@wishket/design-system';
import { Sheet } from 'react-modal-sheet';
import { Fragment } from 'react';

import { BottomSheetRemovableListProps } from './RemovableList.types';
import {
  BottomSheetRemovableItem,
  DefaultBottomSheetRemovableItem,
} from './BottomSheetRemovableList.parts';

import { useDeviceCheck } from '@/shared/hooks';

const BottomSheetRemovableList = ({
  list,
  isOpen,
  onClose,
  onEmptyItemClick,
}: BottomSheetRemovableListProps) => {
  const { isDesktop } = useDeviceCheck();
  const hasItem = list && list.length > 0;
  const showDefaultItem = !(hasItem && isDesktop);

  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      snapPoints={[500]}
      data-testid="bottom-sheet-removable-list"
      style={{ zIndex: 25 }}
    >
      <Sheet.Container className="react-modal-sheet-container">
        <Sheet.Header />
        <Sheet.Content className="pb-10 pl-5 pt-5">
          <Sheet.Scroller className="pr-5 scrollbar-list">
            <Box className="flex flex-col gap-4">
              {showDefaultItem && (
                <DefaultBottomSheetRemovableItem onClick={onEmptyItemClick} />
              )}
              <Divider />
              {hasItem &&
                list.map(({ text, onClick, onRemove }, index) => (
                  <Fragment key={index}>
                    {index !== 0 && <Divider />}
                    <BottomSheetRemovableItem
                      text={text}
                      onClick={onClick}
                      onRemove={onRemove}
                    />
                  </Fragment>
                ))}
            </Box>
          </Sheet.Scroller>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={onClose} />
    </Sheet>
  );
};

export default BottomSheetRemovableList;
